import { SearchFormPanel } from "@magicware/dashboard/Panel";
import DataList from "@magicware/data-lists/DataList";
import { FormStateApiContextProvider } from "@magicware/forms/components/FormStateApiContext";
import { useTranslation } from "react-i18next";
import { apiServerInstanceThunks, setPage } from "../../redux/apiServerInstances/apiServerInstancesReducer";
import { RootState } from "../../redux/types";
import EntityListItemMenuContext from "../entities/EntityListItemMenuContext";
import ApiServerInstanceListItem from "./ApiServerInstanceListItem";
import ApiServerInstanceListMenuContext from "./ApiServerInstanceListMenuContext";
import ApiServerInstanceSearchForm from "./ApiServerInstanceSearchForm";

export default function ApiServerInstanceListPage() {
    const { t } = useTranslation();
    return (
        <FormStateApiContextProvider>
            <SearchFormPanel>
                <ApiServerInstanceSearchForm />
            </SearchFormPanel>
            <ApiServerInstanceListMenuContext>
                <EntityListItemMenuContext
                    deleteSnackTitle={t("apiServiceInstance-deletion")}
                    deleteThunk={apiServerInstanceThunks.delete}
                >
                    <DataList
                        dataSelector={(state: RootState) => state.apiServerInstances.list}
                        setPageActionCreator={setPage}
                        emptyList={t("no-apiServerInstances-message")}
                    >
                        {(id) => <ApiServerInstanceListItem appId={id} />}
                    </DataList>
                </EntityListItemMenuContext>
            </ApiServerInstanceListMenuContext>
        </FormStateApiContextProvider>
    );
}
